import { AtsAnalyticsDirectivesPushEventOnClickModule } from '@alliance/ats/analytics/directives/push-event-on-click'
import { AtsUiLogoModule } from '@alliance/ats/ui/logo'

import { SantaButtonModule } from '@alliance/santa/button'
import { SharedHeaderFeatureHeadlessModule } from '@alliance/shared/header/feature-headless'
import { SharedIconsModule } from '@alliance/shared/icons'
import { SharedTranslationModule } from '@alliance/shared/translation'
import { RenderAsLazyService } from '@alliance/shared/utils'

import { ComponentRef, NgModule, ViewContainerRef } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { PortalModule } from '@angular/cdk/portal'
import { OverlayModule } from '@angular/cdk/overlay'

import { AtsHeaderComponent } from './ats-header/ats-header.component'
import { LazyNavigationPanelComponent } from './ats-header/lazy-navigation-panel/lazy-navigation-panel.component'
import { SharedUiNewBadgeModule } from '@alliance/shared/ui/new-badge'
import { AtsUiStaticTooltipModule } from '@alliance/ats/ui/static-tooltip'
import { LazyManagerPanelComponent } from './ats-header/lazy-manager-panel/lazy-manager-panel.component'

@NgModule({
  imports: [
    CommonModule,
    OverlayModule,
    PortalModule,
    RouterModule,

    SantaButtonModule,
    SharedHeaderFeatureHeadlessModule,
    SharedIconsModule,
    SharedTranslationModule,

    AtsAnalyticsDirectivesPushEventOnClickModule,
    AtsUiLogoModule,
    SharedUiNewBadgeModule,
    AtsUiStaticTooltipModule
  ],
  declarations: [AtsHeaderComponent, LazyNavigationPanelComponent, LazyManagerPanelComponent]
})
export class AtsNavigationFeatureHeaderModule {
  public constructor(private renderAsLazy: RenderAsLazyService) {}

  public renderAtsHeader(viewContainerRef: ViewContainerRef): ComponentRef<AtsHeaderComponent> {
    return this.renderAsLazy.render<AtsHeaderComponent>(viewContainerRef, AtsHeaderComponent)
  }
}
